import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

const opts = {
  options: { customProperties: true },
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
  themes: {
    light: {
      online: '#7EAD61',
      offline: '#CCCCCC',
      primary: '#8CC152',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
    },
    dark: {
      online: '#7EAD61',
      offline: '#CCCCCC',
      primary: '#8CC152',
      secondary: '#424242',
      accent: '#FF4081',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
    },
  },
}

export default new Vuetify(opts)
